import { ElNotification } from "#imports"

const notificationSuccess = (msg = null, title = null) => {
    ElNotification({
      title: title ?? 'Успех',
      message: msg ?? 'Операция выполнена успешно',
      type: 'success',
      zIndex: 3000
    })
  }

  const notificationError = (msg = null, title = null) => {
    ElNotification({
      title: title ?? 'Ошибка',
      message: msg ?? 'Операция не завершена корректно',
      type: 'error',
    })
  }

  const notificationWarning = (msg = null, title = null) => {
    ElNotification({
      title: title ?? 'Предупреждение!',
      message: msg ?? '-',
      type: 'warning',
      duration: 0,
      zIndex: 3000
    })
  }

export {notificationSuccess, notificationError, notificationWarning}